// extracted by mini-css-extract-plugin
export default {"wrapper":"login_wrapper__+pZG9","cta":"login_cta__wxvRF"};